const PATHS: Record<string, JSX.Element> = {
  eye: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  clipboard: (
    <>
      <path d="M9 4.5h6v3H9z" />
      <path d="M15 6h2.5A1.5 1.5 0 0 1 19 7.5v11A1.5 1.5 0 0 1 17.5 20h-11A1.5 1.5 0 0 1 5 18.5v-11A1.5 1.5 0 0 1 6.5 6H9" />
    </>
  ),
  wrench: (
    <path d="M15.5 3.5a5 5 0 0 0-6.1 6.1l-5.2 5.2a1.5 1.5 0 0 0 0 2.1l2.9 2.9a1.5 1.5 0 0 0 2.1 0l5.2-5.2a5 5 0 0 0 6.1-6.1l-3.1 3.1-2.9-2.9Z" />
  ),
  check: <path d="M20 6.5 9.5 17 4 11.5" />,
  flag: (
    <>
      <path d="M5 21V4" />
      <path d="M5 5h11l-1.8 3.2L16 11.5H5" />
    </>
  ),
  calendar: (
    <>
      <rect x="4" y="5.5" width="16" height="14" rx="2" />
      <path d="M4 10h16M9 3.5v4M15 3.5v4" />
    </>
  ),
  hardhat: (
    <>
      <path d="M4 16a8 8 0 0 1 16 0" />
      <path d="M9.5 16V7.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V16" />
      <path d="M3 16.5h18" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="5.5" />
      <path d="M15.5 15.5 20 20" />
    </>
  ),
  box: (
    <>
      <path d="M3.5 8 12 3.5 20.5 8v8L12 20.5 3.5 16V8Z" />
      <path d="M3.5 8 12 12.5 20.5 8M12 12.5v8" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10.5" width="14" height="9" rx="2" />
      <path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
    </>
  ),
  upload: (
    <>
      <path d="M12 16V4.5M8 8l4-3.5L16 8" />
      <path d="M4.5 15v3.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V15" />
    </>
  ),
  alert: (
    <>
      <path d="M12 4.5 21 19.5H3L12 4.5Z" />
      <path d="M12 10v4" />
      <circle cx="12" cy="16.75" r=".85" fill="currentColor" stroke="none" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.6v2.1M12 19.3v2.1M4.2 4.2l1.5 1.5M18.3 18.3l1.5 1.5M2.6 12h2.1M19.3 12h2.1M4.2 19.8l1.5-1.5M18.3 5.7l1.5-1.5" />
    </>
  ),
  moon: <path d="M20.5 14.6A8.6 8.6 0 0 1 9.4 3.5a8.6 8.6 0 1 0 11.1 11.1Z" />,
  external: (
    <>
      <path d="M14.5 4.5H20v5.5" />
      <path d="M20 4.5 12.2 12.3" />
      <path d="M18 13.8v4.7A1.5 1.5 0 0 1 16.5 20h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6h4.7" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 12a8 8 0 1 1-2.5-5.8" />
      <path d="M20 4v4.5h-4.5" />
    </>
  ),
  inbox: (
    <>
      <path d="M3.5 13.5h4l1.5 2.5h6l1.5-2.5h4" />
      <path d="M5.6 5h12.8l2.1 8.5v4A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5v-4L5.6 5Z" />
    </>
  ),
  chevron: <path d="m9 5.5 6.5 6.5L9 18.5" />,
  // Desplegar: los chevrons se abren hacia afuera.
  expand: (
    <>
      <path d="m7 9 5-5 5 5" />
      <path d="m7 15 5 5 5-5" />
    </>
  ),
  // Plegar: se cierran hacia el centro.
  collapse: (
    <>
      <path d="m7 4 5 5 5-5" />
      <path d="m7 20 5-5 5 5" />
    </>
  ),
}

export function Icon({ name, size = 17 }: { name: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name] ?? PATHS['alert']}
    </svg>
  )
}
